var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-way"},[(_vm.loginWay===1)?_c('CaptchaLogin',{on:{"loginWay":_vm.cutLoginWay,"finishLogin":_vm.finishLogin}}):_c('PasswordLogin',{on:{"loginWay":_vm.cutLoginWay,"finishLogin":_vm.finishLogin}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }